import styled from "styled-components";

export const NewStyle = styled.span`
    color: #f58512;
    text-transform: uppercase;
`;
export const LeadGeneratorChangePercentageRightAlign = styled.div`
    text-align: right;
`;
LeadGeneratorChangePercentageRightAlign.displayName = "LeadGeneratorChangePercentageRightAlign";
